module.exports = __webpack_public_path__ + "static/img/900X3N.56a8b1d3.png";